import { requestTypeCreator } from "src/helpers/index";
import { GetDashboardInfoResponseTypes, ActivityFeedResponse } from "./types";

export const GET_DASHBOARD_INFO = requestTypeCreator("GET_DASHBOARD_INFO");
export const GET_ACTIVITY_FEED = requestTypeCreator("GET_ACTIVITY_FEED");

export const getDashboardInfoActions = {
  error: (payload: { error: any }): IActionType<{ error: any }> => ({
    payload,
    type: GET_DASHBOARD_INFO.ERROR
  }),
  request: (payload: { schoolId: number | undefined }) => ({
    payload,
    type: GET_DASHBOARD_INFO.REQUEST
  }),
  success: (payload: GetDashboardInfoResponseTypes): IActionType<GetDashboardInfoResponseTypes> => ({
    payload,
    type: GET_DASHBOARD_INFO.SUCCESS
  })
};

export const getActivityFeedActions = {
  error: (payload: { error: any }): IActionType<{ error: any }> => ({
    payload,
    type: GET_ACTIVITY_FEED.ERROR
  }),
  request: (payload: { schoolId: number; groupId?: number; limit?: number; offset?: number }) => ({
    payload,
    type: GET_ACTIVITY_FEED.REQUEST
  }),
  success: (payload: ActivityFeedResponse): IActionType<ActivityFeedResponse> => ({
    payload,
    type: GET_ACTIVITY_FEED.SUCCESS
  })
};
